const cssVariables = {
  "--primary": "#24335d",
  "--light": "#52bdc8",
  "--dark": "#abc945",
  "--secondary": "#e5efc7",
  "--gray-light": "#acb2b8",
  "--neutral-white": "#FFFFFF",
  "--neutral-medium": "#808485",
  "--neutral-lighter": "#d3d7da",
  "--neutral-dark": "#495056",
  "--neutral": "#F6F7F9",
  "--validate": "#F3FBF1",
  "--validate-dark": "#CDE4C9",
};

module.exports = cssVariables;
